<template>
	<div class="d-flex align-items-stretch h-100 flex-2">
		<leftnav/>
		<router-view/>
		<message/>
		<searchDefault/>
	</div>
</template>
<script>

import searchDefault from '../search/search-default';
import leftnav from '../left-nav';
import message from '../message/message';

export default {
	name: 'home',
	components:{
		searchDefault,
		leftnav,
		message,
	},
	created:function(){
		if (!this.once){
			if (this.$route.name === 'home' && !this.$route.params.map){
				const lastParcelPath = this.$store.getters.getLastParcelPath();
				this.$router.replace({
					path:lastParcelPath
				});
			}
			this.once = true;
		}
		
		if (this.mapLoaded) this.$store.dispatch('MAP_POI_SET',null);
	},
	computed: {
		mapLoaded:function(){
			return this.$store.state.map.loaded;
		}
	},
	data:function(){
		return {
			once:null
		};
	}
}

</script>


// WEBPACK FOOTER //
// src/components/home/home.vue